import { render, staticRenderFns } from "./FocusAreasModal.vue?vue&type=template&id=1c4b3419&scoped=true"
import script from "./FocusAreasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FocusAreasModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b3419",
  null
  
)

export default component.exports